import { makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "400px",
    overflowY: "auto"
  }
}));
